


















import { defineComponent } from '@vue/composition-api';
import { ongoingTasks } from '../state';

export default defineComponent({
  name: 'Loader',
  setup() {
    return { ongoingTasks };
  },
});
